import { Chip } from '@mui/material';

import Card from '@/components/wrapped/Card';
import { type PublishedShortlist } from '@/karehero-app/care/shortlists/fixtures';

// One published shortlist as a card in the care search list: name, a provider
// count + last-updated subtitle, and a "n secured" chip once the family has
// secured anyone on it. Built on the wrapped Card.
const ShortlistSummaryCard = ({
  shortlist,
  onOpen,
}: {
  shortlist: PublishedShortlist;
  onOpen: (shortlist: PublishedShortlist) => void;
}) => {
  // Whether care is secured, not how many. A family secures one placement, so the
  // count was always going to read "1 secured" — a number doing no work next to a
  // word that already says the only thing that matters about this list.
  const isSecured = shortlist.providers.some((p) => p.status === 'Secured');
  // "0 providers" is a true sentence and the wrong one: it reads as a list that
  // came back empty rather than one that is still being answered. On the home
  // screen the card has room for a status and not for an explanation, so it says
  // what is happening and the shortlist itself says why.
  const countLine =
    shortlist.providers.length === 0
      ? `Waiting on providers · ${shortlist.updated}`
      : `${shortlist.providers.length} ${
          shortlist.providers.length === 1 ? 'provider' : 'providers'
        } · ${shortlist.updated}`;

  return (
    <Card
      title={shortlist.name}
      titleVariant='h4'
      subtitle={countLine}
      chip={
        isSecured ? (
          <Chip size='small' color='success' label='Secured' />
        ) : undefined
      }
      onClick={() => onOpen(shortlist)}
    />
  );
};

export default ShortlistSummaryCard;
